import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EConsultantChatActionTypes {
  ToggleOpen = 'consultantChat/toggleOpen',
}

export type TConsultantChatActions = ITypedReduxAction<EConsultantChatActionTypes.ToggleOpen, boolean>;

export const chatToggleOpen = actionGenerator<EConsultantChatActionTypes.ToggleOpen, boolean>(
  EConsultantChatActionTypes.ToggleOpen,
);
